import React from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import ProjectHeader from './ProjectHeader';
import ProgramList from './ProgramList';
import ProjectEditDialog from './ProjectEditDialog';
import ProjectCreateDialog from './ProjectCreateDialog';


export default function Proejct(param) {

    const [showEditBtn, setShowEditBtn] = React.useState(false); // 프로젝트 변경 아이콘 show/hidden처리 플래그 
    const [projectList , setProjectList] = React.useState([]); // 전체 프로젝트 목록
    const [programList, setProgramList] = React.useState([]);
    const [selectedProjectName, setSelectedProjectName] = React.useState('');
    const [selectedProjectId, setSelectedProjectId] = React.useState(''); // 선택한 프로젝트 아이디
    const [selectedProjectUuid, setSelectedProjectUuid] = React.useState(''); // 선택한 프로젝트 uuid

    const [selectedProjectIndex, setSelectedProjectIndex] = React.useState(0); // 선택한 프로젝트의 인덱스 번호
 
    //handler
    function onMouseOverProjectList(){ if(!showEditBtn) setShowEditBtn(true);  }
    function onMouseLeaveProjectList(){ if(showEditBtn) setShowEditBtn(false);  }
    function onClickProjectName(programs, id, name, uuid, index){ selectProject(programs, id, name,uuid); setSelectedProjectIndex(index); }
    function onClickProjectEdit(id, name){
        setSelectedProjectId(id);
        setSelectedProjectName(name);
    }


    // 프로젝트 목록 조회
    async function getProjectList(){
        var url = axiosUrl.project;
        await axios.get(url,{
            params:{
                page: '-1',
                sort: 'createdAt',
                order:'desc'
            }
        })
        .then( response => {
            if(JSON.stringify(projectList) !== JSON.stringify(response.data)) { 
                setProjectList(response.data) ;
                var arr = response.data;
                var size = arr.length ;
                // 프로젝트 정보 새로 가져오면서 기존 선택된 프로젝트 정보 선택하기
                if(size>0)
                    selectProject(arr[selectedProjectIndex].programs, arr[selectedProjectIndex].id, arr[selectedProjectIndex].name, arr[selectedProjectIndex].uuid);
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getProjectList - ' + e.response.data.error.message);
        });

    }

    function selectProject(programs, id, name, uuid){
        setProgramList(programs);
        setSelectedProjectName(name);
        setSelectedProjectId(id);
        setSelectedProjectUuid(uuid);
    }

    function callbackUpdateList(){
        getProjectList();
    }

    React.useEffect(() => {
        getProjectList();

    });

    return(
        <div>

            <div className="content-wrapper">
            
                <ProjectHeader/>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="sticky-top mb-3">
                                    <div className="card">
                                        <div className="card-header  contentColor">
                                            <h4 className="card-title">프로젝트</h4>
                                            <div className="card-header-image">
                                                <a href="" data-toggle="modal" data-target="#ProjectCreateDialog" title="새 프로젝트 추가" ><i className="fas fa-plus"></i></a>
                                            </div>
                                        </div>
                                        
                                        {/* fixed-panel 이걸 div card-body에 추가하면 높이가 고정 됨 */}
                                        <div className="card-body ">
                                            <div id="external-events" >
                                                <ul className="nav nav-pills flex-column" >
                                                    { 
                                                        projectList.map( (value, i) =>
                                                            <li className="nav-item active cursor-pointer" key={i} onMouseOver={onMouseOverProjectList}  onMouseLeave={onMouseLeaveProjectList} onClick={() => onClickProjectName(value.programs, value.id, value.name, value.uuid, i)} >
                                                                    {value.name}
                                                                    {showEditBtn && <a data-toggle="modal" data-target="#ProjectEditDialog" ><i className="fas fa-edit ml-2 text-danger" onClick={() => onClickProjectEdit(value.id, value.name)}></i></a>}
                                                            </li>
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                            
                                </div>
                            </div>
                            <ProgramList callbackUpdateList={callbackUpdateList} programList={programList} projectName={selectedProjectName} projectId={selectedProjectId} projectUuid={selectedProjectUuid}/>
                        </div>
                    </div>
                </section>

                <ProjectEditDialog callbackUpdateList={callbackUpdateList} id={selectedProjectId} name={selectedProjectName} />
                <ProjectCreateDialog callbackUpdateList={callbackUpdateList} />
                    
            </div>

        </div>
        


    );
}